/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateClientSpecificProceedingParticipantRequest,
  CreateProceedingParticipantRequest,
  DeactivateProceedingParticipantRequest,
  MergeProceedingParticipantsRequest,
  ProblemDetails,
  ProceedingParticipantActiveClaimReferencesCountResponse,
  ProceedingParticipantResponse,
  ProceedingParticipantType,
  SearchResultsOfProceedingParticipantSearchResult,
  UpdateProceedingParticipantRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CreateClientSpecificProceedingParticipantRequestFromJSON,
    CreateClientSpecificProceedingParticipantRequestToJSON,
    CreateProceedingParticipantRequestFromJSON,
    CreateProceedingParticipantRequestToJSON,
    DeactivateProceedingParticipantRequestFromJSON,
    DeactivateProceedingParticipantRequestToJSON,
    MergeProceedingParticipantsRequestFromJSON,
    MergeProceedingParticipantsRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ProceedingParticipantActiveClaimReferencesCountResponseFromJSON,
    ProceedingParticipantActiveClaimReferencesCountResponseToJSON,
    ProceedingParticipantResponseFromJSON,
    ProceedingParticipantResponseToJSON,
    ProceedingParticipantTypeFromJSON,
    ProceedingParticipantTypeToJSON,
    SearchResultsOfProceedingParticipantSearchResultFromJSON,
    SearchResultsOfProceedingParticipantSearchResultToJSON,
    UpdateProceedingParticipantRequestFromJSON,
    UpdateProceedingParticipantRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateClientSpecificProceedingParticipantOperationRequest {
    clientId: string;
    createClientSpecificProceedingParticipantRequest: CreateClientSpecificProceedingParticipantRequest;
}

export interface CreateProceedingParticipantOperationRequest {
    createProceedingParticipantRequest: CreateProceedingParticipantRequest;
}

export interface DeactivateProceedingParticipantOperationRequest {
    participantId: string;
    deactivateProceedingParticipantRequest: DeactivateProceedingParticipantRequest;
}

export interface GetClientProceedingParticipantByIdRequest {
    clientId: string;
    participantId: string;
}

export interface GetProceedingParticipantActiveClaimReferencesCountRequest {
    participantId: string;
}

export interface GetProceedingParticipantByIdRequest {
    participantId: string;
}

export interface MergeProceedingParticipantsOperationRequest {
    mergeProceedingParticipantsRequest: MergeProceedingParticipantsRequest;
}

export interface ReactivateProceedingParticipantRequest {
    participantId: string;
}

export interface SearchClientProceedingParticipantsRequest {
    clientId: string;
    searchText?: string;
    includeInactive?: boolean;
    types?: Array<ProceedingParticipantType>;
}

export interface SearchProceedingParticipantsRequest {
    searchText?: string;
    clientId?: string;
    includeInactive?: boolean;
    types?: Array<ProceedingParticipantType>;
}

export interface UpdateClientSpecificProceedingParticipantRequest {
    clientId: string;
    participantId: string;
    updateProceedingParticipantRequest: UpdateProceedingParticipantRequest;
}

export interface UpdateProceedingParticipantOperationRequest {
    participantId: string;
    updateProceedingParticipantRequest: UpdateProceedingParticipantRequest;
}

/**
 * ProceedingParticipantsApi - interface
 * 
 * @export
 * @interface ProceedingParticipantsApiInterface
 */
export interface ProceedingParticipantsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {CreateClientSpecificProceedingParticipantRequest} createClientSpecificProceedingParticipantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    createClientSpecificProceedingParticipantRaw(requestParameters: CreateClientSpecificProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    createClientSpecificProceedingParticipant(requestParameters: CreateClientSpecificProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {CreateProceedingParticipantRequest} createProceedingParticipantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    createProceedingParticipantRaw(requestParameters: CreateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    createProceedingParticipant(requestParameters: CreateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {string} participantId 
     * @param {DeactivateProceedingParticipantRequest} deactivateProceedingParticipantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    deactivateProceedingParticipantRaw(requestParameters: DeactivateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    deactivateProceedingParticipant(requestParameters: DeactivateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    getClientProceedingParticipantByIdRaw(requestParameters: GetClientProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    getClientProceedingParticipantById(requestParameters: GetClientProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {string} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    getProceedingParticipantActiveClaimReferencesCountRaw(requestParameters: GetProceedingParticipantActiveClaimReferencesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantActiveClaimReferencesCountResponse>>;

    /**
     */
    getProceedingParticipantActiveClaimReferencesCount(requestParameters: GetProceedingParticipantActiveClaimReferencesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantActiveClaimReferencesCountResponse>;

    /**
     * 
     * @param {string} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    getProceedingParticipantByIdRaw(requestParameters: GetProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    getProceedingParticipantById(requestParameters: GetProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {MergeProceedingParticipantsRequest} mergeProceedingParticipantsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    mergeProceedingParticipantsRaw(requestParameters: MergeProceedingParticipantsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    mergeProceedingParticipants(requestParameters: MergeProceedingParticipantsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {string} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    reactivateProceedingParticipantRaw(requestParameters: ReactivateProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    reactivateProceedingParticipant(requestParameters: ReactivateProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} [searchText] 
     * @param {boolean} [includeInactive] 
     * @param {Array<ProceedingParticipantType>} [types] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    searchClientProceedingParticipantsRaw(requestParameters: SearchClientProceedingParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfProceedingParticipantSearchResult>>;

    /**
     */
    searchClientProceedingParticipants(requestParameters: SearchClientProceedingParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfProceedingParticipantSearchResult>;

    /**
     * 
     * @param {string} [searchText] 
     * @param {string} [clientId] 
     * @param {boolean} [includeInactive] 
     * @param {Array<ProceedingParticipantType>} [types] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    searchProceedingParticipantsRaw(requestParameters: SearchProceedingParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfProceedingParticipantSearchResult>>;

    /**
     */
    searchProceedingParticipants(requestParameters: SearchProceedingParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfProceedingParticipantSearchResult>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} participantId 
     * @param {UpdateProceedingParticipantRequest} updateProceedingParticipantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    updateClientSpecificProceedingParticipantRaw(requestParameters: UpdateClientSpecificProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    updateClientSpecificProceedingParticipant(requestParameters: UpdateClientSpecificProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

    /**
     * 
     * @param {string} participantId 
     * @param {UpdateProceedingParticipantRequest} updateProceedingParticipantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProceedingParticipantsApiInterface
     */
    updateProceedingParticipantRaw(requestParameters: UpdateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>>;

    /**
     */
    updateProceedingParticipant(requestParameters: UpdateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse>;

}

/**
 * 
 */
export class ProceedingParticipantsApi extends runtime.BaseAPI implements ProceedingParticipantsApiInterface {

    /**
     */
    async createClientSpecificProceedingParticipantRaw(requestParameters: CreateClientSpecificProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createClientSpecificProceedingParticipant().'
            );
        }

        if (requestParameters['createClientSpecificProceedingParticipantRequest'] == null) {
            throw new runtime.RequiredError(
                'createClientSpecificProceedingParticipantRequest',
                'Required parameter "createClientSpecificProceedingParticipantRequest" was null or undefined when calling createClientSpecificProceedingParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/proceeding-participants/clients/{clientId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientSpecificProceedingParticipantRequestToJSON(requestParameters['createClientSpecificProceedingParticipantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async createClientSpecificProceedingParticipant(requestParameters: CreateClientSpecificProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.createClientSpecificProceedingParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createProceedingParticipantRaw(requestParameters: CreateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['createProceedingParticipantRequest'] == null) {
            throw new runtime.RequiredError(
                'createProceedingParticipantRequest',
                'Required parameter "createProceedingParticipantRequest" was null or undefined when calling createProceedingParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/proceeding-participants`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProceedingParticipantRequestToJSON(requestParameters['createProceedingParticipantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async createProceedingParticipant(requestParameters: CreateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.createProceedingParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deactivateProceedingParticipantRaw(requestParameters: DeactivateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling deactivateProceedingParticipant().'
            );
        }

        if (requestParameters['deactivateProceedingParticipantRequest'] == null) {
            throw new runtime.RequiredError(
                'deactivateProceedingParticipantRequest',
                'Required parameter "deactivateProceedingParticipantRequest" was null or undefined when calling deactivateProceedingParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/proceeding-participants/{participantId}/deactivate`;
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeactivateProceedingParticipantRequestToJSON(requestParameters['deactivateProceedingParticipantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async deactivateProceedingParticipant(requestParameters: DeactivateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.deactivateProceedingParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientProceedingParticipantByIdRaw(requestParameters: GetClientProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientProceedingParticipantById().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling getClientProceedingParticipantById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proceeding-participants/clients/{clientId}/{participantId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientProceedingParticipantById(requestParameters: GetClientProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.getClientProceedingParticipantByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProceedingParticipantActiveClaimReferencesCountRaw(requestParameters: GetProceedingParticipantActiveClaimReferencesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantActiveClaimReferencesCountResponse>> {
        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling getProceedingParticipantActiveClaimReferencesCount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proceeding-participants/{participantId}/active-claim-references-count`;
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantActiveClaimReferencesCountResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProceedingParticipantActiveClaimReferencesCount(requestParameters: GetProceedingParticipantActiveClaimReferencesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantActiveClaimReferencesCountResponse> {
        const response = await this.getProceedingParticipantActiveClaimReferencesCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProceedingParticipantByIdRaw(requestParameters: GetProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling getProceedingParticipantById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proceeding-participants/{participantId}`;
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProceedingParticipantById(requestParameters: GetProceedingParticipantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.getProceedingParticipantByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mergeProceedingParticipantsRaw(requestParameters: MergeProceedingParticipantsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['mergeProceedingParticipantsRequest'] == null) {
            throw new runtime.RequiredError(
                'mergeProceedingParticipantsRequest',
                'Required parameter "mergeProceedingParticipantsRequest" was null or undefined when calling mergeProceedingParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/proceeding-participants/merge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeProceedingParticipantsRequestToJSON(requestParameters['mergeProceedingParticipantsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async mergeProceedingParticipants(requestParameters: MergeProceedingParticipantsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.mergeProceedingParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reactivateProceedingParticipantRaw(requestParameters: ReactivateProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling reactivateProceedingParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proceeding-participants/{participantId}/reactivate`;
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async reactivateProceedingParticipant(requestParameters: ReactivateProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.reactivateProceedingParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchClientProceedingParticipantsRaw(requestParameters: SearchClientProceedingParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfProceedingParticipantSearchResult>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling searchClientProceedingParticipants().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['types'] != null) {
            queryParameters['types'] = requestParameters['types'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proceeding-participants/clients/{clientId}/search`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsOfProceedingParticipantSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async searchClientProceedingParticipants(requestParameters: SearchClientProceedingParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfProceedingParticipantSearchResult> {
        const response = await this.searchClientProceedingParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchProceedingParticipantsRaw(requestParameters: SearchProceedingParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfProceedingParticipantSearchResult>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['SearchText'] = requestParameters['searchText'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['ClientId'] = requestParameters['clientId'];
        }

        if (requestParameters['includeInactive'] != null) {
            queryParameters['IncludeInactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['types'] != null) {
            queryParameters['Types'] = requestParameters['types'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proceeding-participants`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsOfProceedingParticipantSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async searchProceedingParticipants(requestParameters: SearchProceedingParticipantsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfProceedingParticipantSearchResult> {
        const response = await this.searchProceedingParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClientSpecificProceedingParticipantRaw(requestParameters: UpdateClientSpecificProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClientSpecificProceedingParticipant().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling updateClientSpecificProceedingParticipant().'
            );
        }

        if (requestParameters['updateProceedingParticipantRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProceedingParticipantRequest',
                'Required parameter "updateProceedingParticipantRequest" was null or undefined when calling updateClientSpecificProceedingParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/proceeding-participants/clients/{clientId}/{participantId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProceedingParticipantRequestToJSON(requestParameters['updateProceedingParticipantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateClientSpecificProceedingParticipant(requestParameters: UpdateClientSpecificProceedingParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.updateClientSpecificProceedingParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateProceedingParticipantRaw(requestParameters: UpdateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProceedingParticipantResponse>> {
        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling updateProceedingParticipant().'
            );
        }

        if (requestParameters['updateProceedingParticipantRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProceedingParticipantRequest',
                'Required parameter "updateProceedingParticipantRequest" was null or undefined when calling updateProceedingParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/proceeding-participants/{participantId}`;
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProceedingParticipantRequestToJSON(requestParameters['updateProceedingParticipantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProceedingParticipantResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateProceedingParticipant(requestParameters: UpdateProceedingParticipantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProceedingParticipantResponse> {
        const response = await this.updateProceedingParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
